import { Descriptions } from 'antd';
import { ApplicantProfileApplyToViewContainerApplicantUserFieldsFragment } from '../../../../generated';
import { ProfileHeader } from './profile-header';

const TITLE = 'Applying to Details';

export interface ProfileApplyToViewProps {
  data: ApplicantProfileApplyToViewContainerApplicantUserFieldsFragment;
  onEditToggle: () => void;
}

export const ProfileApplyToView: React.FC<ProfileApplyToViewProps> = (props) => {
  return (
    <div className="flex flex-col space-y-4 w-[85%] md:w-auto">
      <ProfileHeader title={TITLE} onEdit={props.onEditToggle} />
      <Descriptions title="Organizations to where I'm applying" layout="vertical" size="small" column={1} className="w-[400px] space-y-4">
        {props.data?.personalInformation?.applyingTo?.map((applyingToEntity, index) => (
          <Descriptions.Item label={index === 0 ? 'Sent To' : undefined} key={applyingToEntity?.id} labelStyle={{marginBottom:"8px"}}>
            {applyingToEntity?.entityName}
          </Descriptions.Item>
        ))}
      </Descriptions>
    </div>
  );
};
